const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "activityBanner":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "activityBanner",
    reducer: reducer,
};

export default data;